export var extractTopLevelDomain = function (domain) {
    if (!domain || domain.length === 0) {
        throw new Error('Domain must be specified');
    }
    var segments = domain.split('.');
    if (segments.length < 2) {
        throw new Error("Domain '" + domain + "' does hot have the right format.");
    }
    /* Note:
     *  This approach does not take into the account domains like: ".co.uk"
     *  https://stackoverflow.com/questions/6449340/how-to-get-base-domain-from-the-url-in-javascript
     */
    var tld = segments.pop();
    return tld;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGxkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi90bGQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLElBQU0scUJBQXFCLEdBQStCLFVBQUEsTUFBTTtJQUNyRSxJQUFJLENBQUMsTUFBTSxJQUFJLE1BQU0sQ0FBQyxNQUFNLEtBQUssQ0FBQyxFQUFFO1FBQ2xDLE1BQU0sSUFBSSxLQUFLLENBQUMsMEJBQTBCLENBQUMsQ0FBQztLQUM3QztJQUVELElBQU0sUUFBUSxHQUFhLE1BQU0sQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7SUFFN0MsSUFBSSxRQUFRLENBQUMsTUFBTSxHQUFHLENBQUMsRUFBRTtRQUN2QixNQUFNLElBQUksS0FBSyxDQUFDLGFBQVcsTUFBTSxzQ0FBbUMsQ0FBQyxDQUFDO0tBQ3ZFO0lBRUQ7OztPQUdHO0lBQ0gsSUFBTSxHQUFHLEdBQVcsUUFBUSxDQUFDLEdBQUcsRUFBWSxDQUFDO0lBRTdDLE9BQU8sR0FBRyxDQUFDO0FBQ2IsQ0FBQyxDQUFDIn0=